import { Component, OnInit, Input, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';

import { config } from 'app/constants';
import { DataService, HelperService, HTTPService, DateService } from 'app/services';
import { currency } from 'app/constants/currency.constants';
@Pipe({
  name: 'highlight',
})
export class HighlightSearch implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, args: any): any {
    if (!args) {
      return value;
    }
    // Match in a case insensitive maneer
    const re = new RegExp(args, 'gi');
    const match = value.match(re);

    // If there's no match, just return the original value.
    if (!match) {
      return value;
    }

    const replacedValue = value.replace(re, `<b class="font-bold font-20">${match[0]}</b>`);
    return this.sanitizer.bypassSecurityTrustHtml(replacedValue);
  }
}

@Component({
  selector: 'app-vehicle-history-services',
  templateUrl: './vehicle-history-services.component.html',
  styleUrls: ['./vehicle-history-services.component.scss'],
})
export class VehicleHistoryServicesComponent implements OnInit {
  @Input() campaign: any = {};
  @Input() preAppliedFilter: any = {};
  @Input() vehicleHistory: any = {};
  @Input() vehicleIndex: any = 0;
  @Input() searchQuery: any = '';
  @Input() isMultiLocationEnabled: boolean = false;
  @Input() isSearchEntered: boolean = false;
  @Input() shopsMap: any = {};
  @Input() isTransferVehicleEnabled: boolean = false;
  @Input('options')
  set setOptions(data: any) {
    this.options = data;
    this.filterOptions.customerFleet = this.options.isFleetFilterOn;
    if (this.options.isShowChatStatus) {
    }
  }

  config: any = config;
  options = {
    isSearchBarOn: true, // is search bar visible
    isStatTileVisible: false, // is show stat tile
    isShowAddCustomerButton: true, // show button to add new customer
    isFleetFilterOn: true,
    isShowChatStatus: false,
  };
  customerTags: any[] = [];
  searchResults: any[];
  isLoading: boolean = false;
  // FILTER CONFIGURATION
  filterOptions = {
    status: true,
    tags: true,
    dayFilterOption: false,
    customerFleet: true,
    invoiceDateFilterOption: true,
  };
  serviceStatusBadge = {
    pending: {
      name: 'Not yet authorized',
      class: 'badge-pending',
    },
    approved: {
      name: 'Approved',
      class: 'badge-authorized',
    },
    deferred: {
      name: 'Deferred',
      class: 'badge-deferred',
    },
    deferredLocked: {
      name: 'Deferred locked',
      class: 'badge-deferred',
    },
    declined: {
      name: 'Declined',
      class: 'badge-declined',
    },
    archived: {
      name: 'Archived',
      class: 'badge-pending',
    },
  };
  services: any = [];
  audioCount: any = 0;
  pdfCount: any = 0;
  imageCount: any = 0;
  otherCount: any = 0;
  shopNotesLength: number;
  customerNotesLength: number;
  isDetailExpanded = {
    customerNotes: false,
    shopNotes: false,
  };
  usd: string = currency.USD;

  constructor(public ref: DynamicDialogRef, public helperService: HelperService, private dataService: DataService) {}

  ngOnInit() {
    this.shopNotesLength = this.vehicleHistory.shopNotes && this.vehicleHistory.shopNotes.length;
    this.customerNotesLength = this.vehicleHistory.customerNotes && this.vehicleHistory.customerNotes.length;
    this.services = this.vehicleHistory.services;
    this.setAttachmentCout();
  }

  setAttachmentCout() {
    if (this.vehicleHistory.attachments) {
      this.vehicleHistory.attachments.forEach((attachment) => {
        if (attachment.category === 'EXTERNAL') {
          if (attachment.fileType === 'IMAGE') {
            this.imageCount++;
          } else if (attachment.fileType === 'PDF') {
            this.pdfCount++;
          } else if (attachment.fileType === 'AUDIO') {
            this.audioCount++;
          }
        } else {
          this.otherCount++;
        }
      });
    }

  }

  openServiceInRO(estimateID, event: Event) {
    if (estimateID) {
      const url = `${window.location.origin}/#/estimate/${estimateID}`;
      window.open(url, '_blank');
    }
  }

  openInspectionInRO(estimateID, inspectionId, serviceId) {
    if (estimateID) {
      const inspection = {
        isInspection: true,
        serviceId,
        inspectionId,
      };
      localStorage.setItem('openInsectionModal', JSON.stringify(inspection));
      const url = `${window.location.origin}/#/estimate/${estimateID}`;
      window.open(url, '_blank');
    }
  }

  openImportOrder(vehicleHistory: any, event: Event) {
    if (!vehicleHistory.historyOrder) return false;
    event.stopPropagation();
    event.preventDefault();
    this.dataService.sendData(
      this.dataService.typePassData('open-history-dialog', {
        type: 'history-import',
        isOpenFromRO: false,
        payload: vehicleHistory.estimateId,
      })
    );
  }

  openAttachmentInRO(estimateID) {
    if (estimateID) {
      const url = `${window.location.origin}/#/estimate/${estimateID}`;
      window.open(url, '_blank');
      localStorage.setItem('openROTab', 'attachment');
    }
  }

  closeDialog(data: any) {
    this.ref.close(data);
  }

  isDetailedNotes(key: string) {
    if (key === 'shopNotes') {
      this.isDetailExpanded.shopNotes = !this.isDetailExpanded.shopNotes;
    } else if (key === 'customerNotes') {
      this.isDetailExpanded.customerNotes = !this.isDetailExpanded.customerNotes;
    }
  }
}
